export default __webpack_public_path__ + "static/slide2-tablet-2db21882a1432374a601a6d9e2fff304.png";